import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
export const LabelBox = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ScheduleList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ScheduleItem = styled.li`
  display: flex;
  gap: 24px;
`;

export const DayLabel = styled.span`
  font-size: 16px;
  color: #8e899f;
  padding: 0 12px;
`;

export const TimeLabel = styled.span`
  font-size: 16px;
`;
